import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setConnectionMethod,getSettings, getAccess } from '../../api/admin/settingThunk';
import {Setting2} from '../../../utils/interface';

interface State {
    data:Setting2[] | null;

    message: string;
    isLoading: boolean;
    isError: boolean;

    isFetching:boolean;

    access:boolean;
}

const initialState: State = {
    data :null,
    message: "",
    isLoading: false,
    isError: false,

    isFetching:false,

    access:false,
}

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(setConnectionMethod.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(setConnectionMethod.fulfilled, (state, action: PayloadAction<string>) => {
                state.isLoading = false;
                state.message = action.payload;
            })
            .addCase(setConnectionMethod.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload as string || action.error.message || "An error occurred";
            })

            .addCase(getSettings.pending, (state) => {
                state.isFetching = true;
            })
            .addCase(getSettings.fulfilled, (state, action: PayloadAction<Setting2[]>) => {
                state.isFetching = false;
                state.data = action.payload
            })
            .addCase(getSettings.rejected, (state, action) => {
                state.isFetching = false;
            })  
            
            .addCase(getAccess.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAccess.fulfilled, (state, action: PayloadAction<boolean>) => {
                state.isLoading = false;
                state.access = action.payload;
            })
            .addCase(getAccess.rejected, (state, action) => {
                state.isLoading = false;
            })
    },
});

export default settingSlice.reducer;